import { doc, getDoc, onSnapshot, type Unsubscribe } from "firebase/firestore";
import {
  evaluateEntitlement,
  type EntitlementAccess,
  type EntitlementDocument,
} from "../../domain/access/entitlement";
import { getFirebaseServices } from "./firebase";

function assertCurrentUser(uid: string): void {
  if (!uid || getFirebaseServices().auth.currentUser?.uid !== uid) {
    throw new Error("The requested workspace does not belong to the signed-in account.");
  }
}

export async function readEntitlement(uid: string): Promise<EntitlementAccess> {
  assertCurrentUser(uid);
  const snapshot = await getDoc(doc(getFirebaseServices().firestore, "entitlements", uid));
  return evaluateEntitlement(snapshot.exists() ? snapshot.data() as EntitlementDocument : null);
}

export function observeEntitlement(
  uid: string,
  observer: (access: EntitlementAccess) => void,
  onError?: (error: Error) => void,
): Unsubscribe {
  assertCurrentUser(uid);
  return onSnapshot(
    doc(getFirebaseServices().firestore, "entitlements", uid),
    (snapshot) => observer(evaluateEntitlement(
      snapshot.exists() ? snapshot.data() as EntitlementDocument : null,
    )),
    (error) => onError?.(error),
  );
}

